import React from "react";
import OrderListItem from "./OrderListItem";
import OrderlistWrapper from "./OrderList.style";

const OrdersList = (props) => {
  const {
    effective_orders,
    order_time_extractions,
    ordersPalette,
    onFilterOrdersChanged,
    mode,
    events,
    showApproved,
    filteredOrders,
    currentDate,
  } = props;
  const renderOrders = () => {
    return effective_orders
      ? effective_orders.map((order, i) => (
          <OrderListItem
            onFilterOrdersChanged={onFilterOrdersChanged}
            ordersPalette={ordersPalette}
            order_time_extractions={order_time_extractions}
            order={order}
            key={order.id}
            mode={mode}
            events={events}
            showApproved={showApproved}
            filteredOrders={filteredOrders}
            currentDate={currentDate}
          />
        ))
      : [];
  };
  return <OrderlistWrapper>{renderOrders()}</OrderlistWrapper>;
};

export default OrdersList;
